import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import {GridList, GridListTile} from '@material-ui/core';
import {Dialog, Button} from 'components/core';
import {Add} from '@material-ui/icons';
import Image from 'material-ui-image';
import {ProcedureItemsCtx} from 'components/dataProviders/procedureItems'
import {ItemIcon} from './items';

const style = makeStyles((theme) => ({
    icon:
    {
        width: 40,
        height: 40,
        float: "left",
        position: 'relative',
        marginRight: 10
    },
    gridTile: {
        display: "flex",
        contentAlign: "center",
        '& > *':
        {
            margin: 'auto'
        }
    },
    iconButton:
    {
        backgroundColor: "transparent",
        border: "none",
        borderRadius: 8,
        width: 60,
        height: 60,
        cursor: "pointer",
        '&:hover':
        {
            backgroundColor: theme.palette.input.background
        },
        '&:focus':
        {
            backgroundColor: theme.palette.input.background,
            border: "none",
            outline: "none"
        },

    }
}), {name: "RaymanItemIconSelector"});

export default function IconSelector({iconID, onChange})
{
    const classes = style();
    const ctx = React.useContext(ProcedureItemsCtx);
    const [panelOpen, setPanelOpen] = React.useState(false);

    function handleChangeButtonClick()
    {
        setPanelOpen(true);
    }

    function handlePanelClose()
    {
        setPanelOpen(false);
    }

    function handlePanelSelect(iconID)
    {
        if(onChange) onChange(iconID);
        handlePanelClose();
    }
    return <div>
    <IconSelectorPanel open={panelOpen} onSelect={handlePanelSelect} onClose={handlePanelClose} />
    <div className={classes.icon}>
        <ItemIcon iconID={iconID} />
    </div>
    <Button fullWidth={false} onClick={handleChangeButtonClick}>Cambiar</Button>
    </div>
}

function IconSelectorPanel({open, onSelect, onClose})
{
    const ctx = React.useContext(ProcedureItemsCtx);
    const classes = style();
    return <Dialog open={open} title="Seleccione un icono" onClose={onClose}>
        <GridList cellHeight={60} cols={4} spacing={16} align>
        {ctx.icons.data.array.map((iconID) => (
            <GridListTile key={iconID} cols={1} className={classes.gridTile}>
                <button className={clsx(classes.icon, classes.iconButton)} onClick={()=>onSelect(iconID)}>
                    <ItemIcon iconID={iconID} />
                </button>
            </GridListTile>
        ))}
        </GridList>
    </Dialog>
}